module.exports = __webpack_public_path__ + "stylesheets/search-page_54d8c1c459485c5bfc9e9b16c5be2b36.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/search-page.less
// module id = mIzu
// module chunks = 55